import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, FormGroup, Label, Input, CardText, Button, CardSubtitle, Table, ModalFooter } from 'reactstrap';
import { FaPlus, FaEdit, FaEye } from 'react-icons/fa';
import axios from 'axios';
import uuid from 'react-uuid';
import Moment from 'moment';
import "../ExternalOrganisation/ExternalOrganisation.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const Subscriptions = () => {
    const [subscriptionList, setSubscriptionList] = useState([]); const [loading, setLoading] = useState(true); const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(0); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const navigate = useNavigate();
    const [name, setName] = useState('');
    const [tempSubscriptionList, setTempSubscriptionList] = useState([]);
    const populateItemData = async () => {
        try {
            const response = await axios.get(
                '/api/Subscription/GetSubscriptions/', {
                params: { UserId: userId }
            }
            );
            setSubscriptionList(response.data.content);
            setTempSubscriptionList(response.data.content);
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const open = (id, routePath) => {
        navigate('/' + routePath, { state: { id: id } });
    }

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = React.useState(config);
        if (sortConfig == null) {
            setSortConfig({ key: 'name', direction: 'ascending' });
        }
        const sortedItems = React.useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = (key) => {
            let direction = 'ascending';
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };
    const ProductTable = (props) => {
        const { items, requestSort, sortConfig } = useSortableData(props.products);
        const getClassNamesFor = (name) => {
            if (!sortConfig) {
                return;
            }
            return sortConfig.key === name ? sortConfig.direction : undefined;
        };
        return (
            <Table striped bordered hover style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('subscriptionId')}
                                className={getClassNamesFor('subscriptionId')}
                            >
                                Subscription Id
                            </button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                            Status
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('email')}
                                className={getClassNamesFor('email')}
                            >
                                Email
                            </button>
                        </th>
                        <th>
                            Farms
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('type')}
                                className={getClassNamesFor('type')}
                            >
                                Type
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('startDate')}
                                className={getClassNamesFor('startDate')}
                            >
                                Start Date
                            </button>
                        </th>
                        <th>
                            <button
                                type="button"
                                onClick={() => requestSort('expiryDate')}
                                className={getClassNamesFor('expiryDate')}
                            >
                                Expiry Date
                            </button>
                        </th>
                        <th style={{ textAlign: "center" }}>
                            View
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items == undefined &&
                        <tr><td colSpan="5" style={{ textAlign: "center" }}>Loading...</td></tr>
                    }
                    {items != undefined && items != null && items.map(item => (
                        <tr key={uuid()}>
                            <td style={{ textAlign: "" }}>{item.subscriptionId}</td>
                            <td style={{ textAlign: "center" }}>{item.status == 'active' &&
                                <img title={item.status} src="/images/ActiveStatus.png" className="card_icon" ></img>
                            }
                                {
                                    item.status != 'active' &&
                                    <img title={item.status} src="/images/NonActiveStatus.png" className="card_icon" ></img>
                                }
                            </td>
                            <td style={{ textAlign: "" }}>{item.email} </td>
                            <td style={{ textAlign: "" }}>{item.farms} </td>
                            <td style={{ textAlign: "" }}>{item.type} </td>
                            <td style={{ textAlign: "" }}>{item.startDate != null ? moment(item.startDate).format("DD/MM/YYYY") : ""}</td>
                            <td style={{ textAlign: "" }}>{item.expiryDate != null ? moment(item.expiryDate).format("DD/MM/YYYY") : ""}</td>
                            <td style={{ textAlign: "center" }}>
                                <button style={{ backgroundColor: "#0d535d" }} type="button" onClick={(id, routePath) => open(item.subscriptionId, 'viewsubscription')}
                                    id="btnUpdate"
                                    color="warning"
                                    className="btn btn-sm btn-edit">
                                    <FaEye />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    const handleChangeName = async (event) => {
        setName(event.target.value);
        if (event.target.value == '') {
            setSubscriptionList(tempSubscriptionList);
        }
        else {
            var list = [];
            list = tempSubscriptionList.filter(x => (x.subscriptionId != null ? x.subscriptionId.toLowerCase().includes(event.target.value.toLowerCase()) : 0)
                || (x.email != null ? x.email.toLowerCase().includes(event.target.value.toLowerCase()) : 0)
                || (x.farms != null ? x.farms.toLowerCase().includes(event.target.value.toLowerCase()) : 0)
                || (x.type != null ? x.type.toLowerCase().includes(event.target.value.toLowerCase()) : 0)
            );
            setSubscriptionList(list);
        }
    }

    return (
        <div>

            <Card className="my-4">
                <h2 className="card-header d-flex justify-content-between align-items-center">
                    Subscriptions
                </h2>
                <CardBody>
                    <Row >
                        <Col md="9">
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col>
                            {subscriptionList == undefined &&
                                <tr><td colSpan="5" style={{ textAlign: "center" }}>Loading...</td></tr>
                            }
                            {subscriptionList != undefined && subscriptionList != null && <ProductTable products={subscriptionList} />}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

export default Subscriptions;